export default {
  changeTheme(state, payload) {
    state.current_theme = payload;
  },
};
